/**
 * fetch() 直接呼び出し時のエラーレスポンスボディを解析してメッセージを返す。
 * apiError() は { error, code } を返すため body.error を優先する。
 * 後方互換として body.message もフォールバックとして扱う。
 */
export async function parseQueryErrorMessage(res: Response): Promise<string> {
  const body = await res.json().catch(() => ({})) as Record<string, unknown>
  return (
    (typeof body.error === 'string' && body.error) ||
    (typeof body.message === 'string' && body.message) ||
    `API error: ${res.status}`
  )
}
